import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

const StyledBorderedBox = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    borderStyle: 'solid',
    borderWidth: '1px 5px 5px 1px',
    borderRadius: '1.5rem',
    lineHeight: 0,
    padding: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem'
    }
  })
});
export const BorderedBox = ({
  className,
  children,
  'data-testid': testId,
  ...rest
}) => (
  <>
    <StyledBorderedBox
      className={className}
      data-testid={testId}
      {...rest}
    >
      {children}
    </StyledBorderedBox>
  </>
);

BorderedBox.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.shape({}),
  'data-testid': PropTypes.string
};

BorderedBox.defaultProps = {
  children: null,
  sx: {}
};
